export default __webpack_public_path__ + "static/media/generate-data.798ea799.svg";